import { Companion_getInstance1mbpsjm598j6x as Companion_getInstance } from '../type/SecretId.mjs';
import {
  notNull3hndh47e9bowl as notNull,
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstanceahck8e8hndj as Companion_getInstance_0 } from '../type/GraphQLString.mjs';
import { Companion_getInstance1g8urmo0p9pl7 as Companion_getInstance_1 } from '../type/DateTimeISO.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Companion_getInstance3p1g7krn6366s as Companion_getInstance_2 } from '../type/SecretToken.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance_3 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CreateSecretMutationSelectionsClass;
function CreateSecretMutationSelections() {
  if (CreateSecretMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        CreateSecretMutationSelections_instance = this;
        this.y6p_1 = listOf([(new (Builder())('secretId', notNull(Companion_getInstance().q70_1))).l38(), (new (Builder())('description', notNull(Companion_getInstance_0().y6z_1))).l38(), (new (Builder())('createdTimestamp', notNull(Companion_getInstance_1().u6z_1))).l38(), (new (Builder())('lastUsedTimestamp', Companion_getInstance_1().u6z_1)).l38(), (new (Builder())('secretToken', notNull(Companion_getInstance_0().y6z_1))).l38()]);
        this.z6p_1 = listOf_0((new (Builder())('createSecret', Companion_getInstance_2().v70_1)).p47(listOf_0((new (Builder_0())(Companion_getInstance_3().o6p_1)).a48(new (CompiledVariable())('input')).l38())).q47(this.y6p_1).l38());
      }
    }
    initMetadataForObject($, 'CreateSecretMutationSelections');
    CreateSecretMutationSelectionsClass = $;
  }
  return CreateSecretMutationSelectionsClass;
}
var CreateSecretMutationSelections_instance;
function CreateSecretMutationSelections_getInstance() {
  if (CreateSecretMutationSelections_instance === VOID)
    new (CreateSecretMutationSelections())();
  return CreateSecretMutationSelections_instance;
}
//region block: exports
export {
  CreateSecretMutationSelections_getInstance as CreateSecretMutationSelections_getInstance1akwpva7hkktk,
};
//endregion

//# sourceMappingURL=CreateSecretMutationSelections.mjs.map
